/**
 * @prettier
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { browserHistory } from 'react-router';
import createFragment from 'react-addons-create-fragment';
import _ from 'lodash';
import classNames from 'classnames';
import { trackOnboardingStarted, onboardTrackingConstants } from '@zola-helpers/client';

import { getThemesV2, resetThemes, getThemesFiltering, onResetThemeKey } from '../../../actions/website/ThemeActions';
import { fetchHiddenPageSuggestions } from '../../../actions/website/PageActions';
import { updateWeddingTheme, fetchWeddingThemeGroup, toggleWebsite } from '../../../actions/WeddingActions';
import { fetchRegistry } from '../../../actions/RegistryActions';
import { showModal } from '../../../actions/ModalActions';
import ManageWebsiteActions from './entities/ManageWebsiteActions';
import CurrentThemeViewer from './CurrentThemeViewer';
import ThemesFilter from './ThemesFilter';
import ThemeGroup from './ThemeGroup';
import scrollViewTo from '../../../util/scrollViewTo';
import { getClearClass } from '../../util/themeClearClass';
import SecondaryNav from '../../common/header/SecondaryNav/SecondaryNav';
import { weddingWebsiteNavItems } from '../../common/header/SecondaryNav/secondaryNavData';
import '../../../stylesheets/pages/EditPage.less';
import { deleteLocalStorage, deleteCookie, getCookie, getLocalStorage } from '../../../util/storage';
import featureFlags from '../../../util/featureFlags';

const trackOnboardingStartedOnce = _.once(trackOnboardingStarted);

class Themes extends Component {
  constructor(props) {
    super(props);
    const blockOnboardStartTracking =
      getCookie('blockOnboardStartTracking') === 'website' ||
      getLocalStorage('blockOnboardStartTracking') === 'website';
    this.state = {
      offset: 0,
      // onboardActive: onboard,
      filterOptions: {},
      // themeGroup: props.themeGroup,
      // themeGroupTitle: props.themeGroupTitle,
      blockOnboardStartTracking,
    };
    this.getMoreThemes = this.getMoreThemes.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.toggleWebsitePublish = this.toggleWebsitePublish.bind(this);
    this.onResetThemes = this.onResetThemes.bind(this);
    this.generateThemeTiles = this.generateThemeTiles.bind(this);
  }

  componentWillMount() {
    const { weddingTheme, getThemeGroup } = this.props;
    if (this.props.themes.busy) {
      return;
    }
    if (weddingTheme.key) {
      getThemeGroup(weddingTheme.key);
    }
    if (window.zolaNav) {
      window.zolaNav.setTopLinkActive();
    }
  }

  componentDidMount() {
    const { registry, hasRegistry, getRegistry, onboard } = this.props;
    const { blockOnboardStartTracking } = this.state;

    // if registry status doesn't exist, that means registry info has not been fetched yet
    if (hasRegistry && !registry.status) {
      getRegistry();
    }

    const scrollToAnchor = () => {
      const { currentThemeKey, themeGroupKey } = this.props;
      const scrollElement = currentThemeKey;
      const backUpScrollElement = themeGroupKey;
      if (scrollElement) {
        const el = document.getElementById(scrollElement);
        if (el) {
          this.scrollTo(el);
        } else if (!el) {
          const themeGroupEl = document.getElementsByClassName(backUpScrollElement)[0];
          this.scrollTo(themeGroupEl);
        }
      }
    };
    setTimeout(scrollToAnchor, 10);

    if (onboard && !blockOnboardStartTracking) {
      const { BUSINESS_UNIT, COMPONENT } = onboardTrackingConstants;
      trackOnboardingStartedOnce(BUSINESS_UNIT.WEDDINGS, COMPONENT.WEDDING_WEBSITE, true);
    }

    deleteLocalStorage('blockOnboardStartTracking');
    deleteCookie('blockOnboardStartTracking');
  }

  onFilterChange(filters) {
    const { filterThemes, loadThemes, unloadThemes } = this.props;
    unloadThemes();
    this.setState(
      {
        filterOptions: filters,
        offset: 0,
      },
      () => {
        filterThemes(this.state.filterOptions.selectedColorKeys, this.state.filterOptions.hasMatchingInvitation);
        loadThemes(this.state.offset);
      }
    );
  }

  onResetThemes() {
    const { unloadThemes } = this.props;
    unloadThemes();
  }

  getMoreThemes() {
    if (this.props.themes.busy) {
      return;
    }
    const { offset } = this.state;
    const { loadThemes } = this.props;
    this.setState({ offset: offset + 10 });
    loadThemes(offset);
  }

  scrollTo(el) {
    const { resetThemeKey } = this.props;
    if (el) {
      scrollViewTo(el);
      window.scrollBy(0, -112);
      resetThemeKey();
    }
  }

  toggleWebsitePublish() {
    const { onTogglePublish, openHidePagesModal, account } = this.props;
    if (account.published) {
      onTogglePublish(false);
    } else {
      openHidePagesModal();
    }
  }

  generateThemeTiles() {
    const { themes, setWeddingTheme, weddingSlug, currentThemeKey, onboard, weddingTheme } = this.props;
    const themeGroups = themes.theme_group_views;
    const themeList = [];
    if (themeGroups) {
      themeGroups.forEach((themeGroup, i) => {
        const idx = i < 7 ? i : i + 1;
        if (i === 7) {
          themeList.push(
            createFragment({
              tile: (
                <ThemeGroup
                  currentTheme={currentThemeKey}
                  themeGroup={themeGroup}
                  weddingTheme={weddingTheme}
                  setWeddingTheme={setWeddingTheme}
                  onboard={onboard}
                  weddingSlug={weddingSlug}
                  themeIndex={i}
                />
              ),
              clearFix: getClearClass(i),
            })
          );
        }
        themeList.push(
          createFragment({
            tile: (
              <ThemeGroup
                currentTheme={currentThemeKey}
                themeGroup={themeGroup}
                weddingTheme={weddingTheme}
                setWeddingTheme={setWeddingTheme}
                onboard={onboard}
                weddingSlug={weddingSlug}
                themeIndex={idx}
              />
            ),
            clearFix: getClearClass(idx),
          })
        );
      });
    }
    return themeList;
  }

  render() {
    const { themes, onboard, weddingTheme, themeGroupTitle, slug, shareInfo, pageKey, published } = this.props;
    const resultCount = themes.result_count;
    const hasMatchingInvitation = true;
    return (
      <div>
        <div>
          {!onboard && (
            <div>
              {!featureFlags.get('navRedesign') && (
                <Fragment>
                  <span className="visible-md-block visible-lg-block">
                    <SecondaryNav
                      slug={slug}
                      pageKey={pageKey}
                      shareInfo={shareInfo}
                      navItems={weddingWebsiteNavItems}
                      altActive={false}
                    />
                  </span>
                  <span className="hidden-md hidden-lg">
                    <SecondaryNav
                      slug={slug}
                      pageKey={pageKey}
                      shareInfo={shareInfo}
                      navItems={weddingWebsiteNavItems}
                      altActive={false}
                    />
                  </span>
                </Fragment>
              )}
              <div className={classNames('manage-website', 'manage-website__container')}>
                <div>
                  <div className="row">
                    <h1 className="page-heading col-sm-6">View Designs</h1>
                    <ManageWebsiteActions
                      slug={slug}
                      published={published}
                      pageKey={pageKey}
                      publishWebsite={this.toggleWebsitePublish}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="theme-page">
          <div>
            <div id="current-theme-viewer-container">
              <CurrentThemeViewer theme={weddingTheme} themeGroupTitle={themeGroupTitle} />
            </div>
            <div className="below-fold-container">
              <div className="filter-container" id="themes-filter-container">
                <ThemesFilter
                  onFilterChange={this.onFilterChange}
                  hasMatchingInvitation={hasMatchingInvitation}
                  onResetThemes={this.onResetThemes}
                />
              </div>
              <div className="col-md-10 col-lg-10 col-lg-offset-0 scroll-container">
                <div id="themes-container">
                  {resultCount > 0 && (
                    <div className="result-count">
                      <p className="sans-text">
                        {resultCount} Design{resultCount !== 1 ? 's' : null}
                      </p>
                    </div>
                  )}
                  {themes && (
                    <InfiniteScroll
                      loadMore={this.getMoreThemes}
                      hasMore={this.state.offset < resultCount}
                      initialLoad={false}
                      threshold={20}
                    >
                      {this.generateThemeTiles()}
                    </InfiniteScroll>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Themes.propTypes = {
  themes: PropTypes.shape({
    theme_group_views: PropTypes.arrayOf(PropTypes.shape({})),
    color_options: PropTypes.arrayOf(PropTypes.shape({})),
    selected_color_keys: PropTypes.array,
    resultCount: PropTypes.number,
    limit: PropTypes.number,
    offset: PropTypes.number,
    busy: PropTypes.bool,
  }),
  themeGroup: PropTypes.shape({
    themes: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  weddingTheme: PropTypes.shape({}),
  themeGroupTitle: PropTypes.string,
  loadThemes: PropTypes.func.isRequired,
  filterThemes: PropTypes.func.isRequired,
  unloadThemes: PropTypes.func.isRequired,
  setWeddingTheme: PropTypes.func.isRequired,
  onboard: PropTypes.bool,
  weddingSlug: PropTypes.string,
  getThemeGroup: PropTypes.func.isRequired,
  currentThemeKey: PropTypes.string,
  resetThemeKey: PropTypes.func.isRequired,
  themeGroupKey: PropTypes.string,
  slug: PropTypes.string,
  shareInfo: PropTypes.shape({}),
  published: PropTypes.bool,
  pageKey: PropTypes.string,
  onTogglePublish: PropTypes.func,
  openHidePagesModal: PropTypes.func,
  account: PropTypes.shape({}),
  registry: PropTypes.shape({}),
  hasRegistry: PropTypes.bool,
  getRegistry: PropTypes.func,
};

const mapStateToProps = state => ({
  themes: state.website.themeListing,
  weddingTheme: state.wedding.theme,
  onboard: !state.wedding.account.disable_website_onboarding,
  weddingSlug: state.wedding.wedding.slug,
  themeGroup: state.website.themeListing.themeDetails,
  themeGroupTitle: state.wedding.themeGroupTitle,
  currentThemeKey: state.website.themeListing.themeKey ? state.website.themeListing.themeKey : null,
  themeGroupKey: state.website.themeListing.themeGroupKey ? state.website.themeListing.themeGroupKey : null,
  slug: state.wedding.wedding.slug,
  shareInfo: Object.assign({}, _.pick(state.wedding.account, 'enable_passcode', 'passcode')),
  published: state.wedding.account.published,
  account: state.wedding.account,
  registry: state.registry,
  hasRegistry: state.user.userContext.has_registry,
  weddingThemeKey: state.wedding.theme.key,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadThemes: offset => {
    dispatch(getThemesV2(offset));
  },
  getThemeGroup: key => dispatch(fetchWeddingThemeGroup(key)),
  filterThemes: (selectedColorKeys, hasMatchingInvitation) => {
    dispatch(getThemesFiltering(selectedColorKeys, hasMatchingInvitation));
  },
  unloadThemes: () => dispatch(resetThemes()),
  setWeddingTheme: (themeKey, e, onboard) => {
    e.preventDefault();
    dispatch(updateWeddingTheme(themeKey)).then(() => {
      if (onboard) {
        browserHistory.push('/wedding/manage/website/pages');
      }
    });
  },
  resetThemeKey: () => dispatch(onResetThemeKey()),
  openShare: wedding => {
    dispatch(showModal('SHARE', { wedding }, { size: 'md' }));
  },
  // control publish modal action creator
  onPublishWebsite: publish =>
    dispatch(toggleWebsite(publish))
      .then(() => {
        dispatch(showModal('PUBLISH_WEBSITE', {}, { size: 'md' }));
      })
      .then(() => {
        if (ownProps.afterPublish) {
          return ownProps.afterPublish();
        }
        return false;
      }),

  // redirect test publish modal action creator
  onPublishWebsiteVA: () =>
    dispatch(toggleWebsite(true)).then(() => {
      if (ownProps.afterPublish) {
        return ownProps.afterPublish();
      }
      return dispatch(
        showModal('INVITE_REDIRECT_MODAL_VARIATION_A', { disableClose: true, hideClose: true }, { size: 'md' })
      );
    }),
  onPublishWebsiteVB: () =>
    dispatch(toggleWebsite(true)).then(() => {
      if (ownProps.afterPublish) {
        return ownProps.afterPublish();
      }
      return dispatch(showModal('INVITE_REDIRECT_MODAL_VARIATION_B', {}, { size: 'md' }));
    }),
  onTogglePublish: publish => dispatch(toggleWebsite(publish)),
  openHidePagesModal: () => dispatch(showModal('HIDE_PAGES', {}, { size: 'md' })),
  getRegistry: () => dispatch(fetchRegistry()),
  getHiddenPageSuggestions: () => dispatch(fetchHiddenPageSuggestions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Themes);



// WEBPACK FOOTER //
// ./src/components/manage/website/Themes.jsx